/**
################################
 * Component geeg_video_section
 * Built with Maciste / Version 2.0
################################
*/



'use strict';

jQuery(document).ready(function ($) {
    // console.log('video_background');

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 1) {
            $('.arrow').addClass('fade');
        } else{
            $('.arrow').removeClass('fade');
        }
    })
});

